import React from "react"
import styles from "./styles.scss"
import Waypoint from "react-waypoint"

import CaseStudyLinks from "./CaseStudyLinks"
import Previews from "./Previews"
import MenuBar from "components/MenuBar"
import CaseStudyProvider from "components/CaseStudyProvider"

class Hero extends React.Component {
  state = { selectedCaseStudyId: 1, visible: false }

  onEnter = () => this.setState({ visible: true })

  onLeave = () => this.setState({ visible: false })

  setProject = selectedCaseStudyId => this.setState({ selectedCaseStudyId })

  render() {
    const { selectedCaseStudyId, visible } = this.state

    return (
      <Waypoint onEnter={this.onEnter} onLeave={this.onLeave}>
        <header className={styles.container} id="home">
          <MenuBar />
          <CaseStudyProvider
            render={caseStudies => {
              const featured = caseStudies.filter(x => x.featuredOnLandingPage)
              const selectedCaseStudy = featured.find(
                x => x.id === selectedCaseStudyId
              )

              return (
                <div className={styles.wrapper}>
                  <Previews
                    backgroundImage={selectedCaseStudy.landingPageHeroImage}
                    visible={visible}
                  />
                  <section className={styles.copy}>
                    <h1>
                      Digital byrå
                      <br />
                      med fokus på
                      <br /> värdeskapande
                    </h1>

                    <p className={styles.copyDescription}>
                      SAITS hjälper er med digital produktutveckling
                      <br />
                      och IT-konsultation när hög kvalitet är ett måste.
                    </p>
                  </section>

                  <CaseStudyLinks
                    caseStudies={featured}
                    onHover={this.setProject}
                  />
                </div>
              )
            }}
          />
        </header>
      </Waypoint>
    )
  }
}

export default Hero



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Hero/index.jsx